import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.js';
//import { CoachSessionPaymentRollupSortableColumn } from '@airreading/common/data';
import { Ellipsis } from 'lucide-react';
import { Button } from '@/components/ui/button.js';
import { useState } from 'react';
import { DeletePayment } from './delete-payment.js';
import { coachPaymentKind, CoachPaymentKind, CoachPaymentNote } from '@airreading/common/data';
import { Link } from '@tanstack/react-router';
import { FromOptions } from './from-options.js';
import { EditPaymentNote } from './edit-payment-note.js';

type KebabOptionsProps = {
  id: string;
  teacherId: string;
  type: CoachPaymentKind;
  from: FromOptions;
  notes: CoachPaymentNote[];
  'data-testid'?: string;
};

export const KebabOptions = (props: KebabOptionsProps) => {
  const { id, teacherId, type, from, notes, 'data-testid': dataTestId } = props;

  const [showDeleteDialog, setShowDeleteDialog] = useState<'delete' | 'editNote' | null>(null);

  const isTeachingPayment = type === coachPaymentKind.enum.teaching;

  const onOpenChange = (open: boolean) => {
    if (!open) {
      setShowDeleteDialog(null);
    }
  };

  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size={'xs'} data-testid={dataTestId}>
            <Ellipsis />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuGroup>
            <DropdownMenuItem asChild disabled={isTeachingPayment}>
              <Link to={`/teachers/${teacherId}/payments?editId=${id}`}>Update payment</Link>
            </DropdownMenuItem>
            <DropdownMenuItem disabled={isTeachingPayment} onClick={() => setShowDeleteDialog('delete')}>
              Delete payment
            </DropdownMenuItem>
            <EditPaymentNote id={id} notes={notes} from={from} />
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <DeletePayment isOpen={showDeleteDialog === 'delete'} onOpenChange={onOpenChange} id={id} from={from} />
    </>
  );
};
